import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import Icon from 'components/icon/icon'

import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { MainContext } from 'context'

import { Draggable, Droppable } from 'react-beautiful-dnd'

import {
	getAvailableNotes
} from 'utils'

class MainHeaderNav extends Component {
	getVisibleNavTabs = _ => {
		const visibleNavTabs = []

		const {
			navtabs
		} = this.props

		navtabs && navtabs.forEach(tab => {
			if (!tab.hidden) {
				visibleNavTabs.push(tab)
			}
		})

		return visibleNavTabs
	}

	render() {
		const {
			type,
			right,
			currentProject,
			relUrl,
			notes,
			callback,
			location,
			isActiveCheck,
			collapsesNames,
			hasDragDropContext,
			setHoveredMainHeaderNavElement,
			handleDragMouseUp,
		} = this.props

		const visibleNavTabs = this.getVisibleNavTabs()

		const {
			roles
		} = this.context

		const className = (() => {
			const itemCount = visibleNavTabs ? visibleNavTabs.length : 0

			let _className = `main-header-nav ${type} items-${itemCount}`

			if (right) {
				_className += ' right'
			}

			if (collapsesNames) {
				_className += ' collapses-names'
			}

			return _className
		})()

		return (
			<React.Fragment>
				<ul 
					className={className}
					onMouseLeave={() => {
						if(setHoveredMainHeaderNavElement){
							setHoveredMainHeaderNavElement(null)
						}
					}}
				>
					{visibleNavTabs.map((object, i) => {
						if (!object || (type == 'tabs' && !currentProject) || object.hidden) {
							return null
						}

						const {
							path,
							name,
							is_root,
							onboarder,
							isActive,
							icon
						} = object

						const _callback = object.callback ? object.callback : callback

						const _isActive = isActiveCheck ? isActiveCheck(i) : isActive

						let count = null

						if (object.count) {
							if (currentProject[path]) {
								count = currentProject[path].length

								if (path === 'notes' && notes) {
									count = getAvailableNotes(currentProject, notes, roles).length

									if (count == 1) {
										const firstNote = notes[currentProject.notes[0]]

										if (!firstNote || !firstNote.text || firstNote.text === '<p><br></p>') {
											count = 0
										}
									}
								}
							}
						}

						const urlSegments = location.pathname.split('/')
						const lastUrlSegment = urlSegments[urlSegments.length - 1]

						const _icon = is_root ? 'fe-home' : icon

						const inner = (
							<React.Fragment>
								{
									(type == 'tabs' || type == 'routes') ?
										<NavLink
											className={(path == 'tasks' && lastUrlSegment == 'gantts') ? 'active' : null}
											to={relUrl + '/' + path}
											activeClassName="active"
										>
											{name}
											{count ?
												<span className="count">
													{count}
												</span>
												: null}
										</NavLink>
										:
										<button
											className={`tooltip-trigger ${_isActive ? 'active' : ''}`}
											key={i}
											onClick={_ => { _callback(object, i) }}
										>
											{_icon &&
												<Icon name={_icon} />
											}
											{!is_root &&
												<span>
													{name}
												</span>
											}
											{(collapsesNames && !_isActive) &&
												<div className="tooltip">
													{name}
												</div>
											}
										</button>
								}
								{onboarder ? onboarder : null}
							</React.Fragment>
						)

						if (!hasDragDropContext) {
							return (
								<li key={i}>
									{inner}
								</li>
							)
						}

						return (
							<Droppable
								droppableId={`folder-${object.id}-2`}
								key={`folder-${object.id}-2`}
								type="FOLDER"
								direction={'horizontal'}
							>
								{(provided, snapshot) => {
									return (
										<li
											ref={provided.innerRef}
											{...provided.droppableProps}
											onMouseEnter={() => {
												if(setHoveredMainHeaderNavElement){
													setHoveredMainHeaderNavElement(object.id)
												}
											}}
											onMouseUp={() => {
												if(handleDragMouseUp){
													handleDragMouseUp()
												}
											}}
										>
											{inner}
											<div style={{ display: 'none' }}>
												{provided.placeholder}
											</div>
										</li>
									)
								}}
							</Droppable>
						)
					})
					}
				</ul>
			</React.Fragment>
		)
	}
}

const mapStateToProps = state => {
	return {
		notes: state.account.entities.notes
	}
}

export default withRouter(connect(mapStateToProps)(MainHeaderNav))

MainHeaderNav.contextType = MainContext